import { createBeam } from "@randajan/bifrost/client/beam";
import { bifrost } from "../bifrost";

import { _defaultLexicon } from "../../../arc/locale/consts";

export const localeBeam = createBeam(bifrost, "/locale", {
    trait:async (lexiconData)=>_defaultLexicon.extend(lexiconData).select(lexiconData.locales[0])
});
